import {
  ComponentProps,
  FC,
  FunctionComponent,
  useContext,
  SyntheticEvent,
} from "react";
import styled from "styled-components";
import {
  Widget,
  WidgetProps,
  WIDGET_BORDER_RADIUS,
} from "../../../../../components/widget";
import { device } from "../../../../../styles/media";
import { StepperContext } from "../../../../../components/stepper/context";

export const StyledWidget = styled(Widget)``;

export const Inner = styled.form`
  padding: 1em;
  border-radius: ${WIDGET_BORDER_RADIUS};

  @media ${device.laptop} {
    overflow: auto;
    padding: 4em 1em;
  }

  ${StyledWidget} {
    margin-bottom: 1em;
  }
  ${StyledWidget}:last-child {
    margin-bottom: 3em;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 50em;
  margin: auto;
`;

export const Container: FC<ComponentProps<typeof Inner>> = ({
  children,
  className,
  ...props
}) => {
  const { next } = useContext(StepperContext);

  return (
    <Inner onSubmit={(e: SyntheticEvent) => next.next(e)} {...props}>
      <Wrapper className={className}>
        {children}
        <input type="submit" hidden />
      </Wrapper>
    </Inner>
  );
};

export const FormWidget: FunctionComponent<WidgetProps> = (props) => {
  return <Widget {...props} />;
};
